(() => {
  const HEADING_TEXT = 'was suchst du heute?';
  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim().toLocaleLowerCase('de-DE');

  const findSection = () => {
    const headings = [...document.querySelectorAll('.lg-section-heading h2')];
    const heading = headings.find((node) => normalize(node.textContent) === HEADING_TEXT);
    if (!heading) return null;

    const headingWrap = heading.closest('.lg-section-heading');
    let row = headingWrap?.nextElementSibling;

    while (row && !row.classList.contains('lg-intent-grid')) {
      row = row.nextElementSibling;
    }

    if (!headingWrap || !row) return null;
    return { headingWrap, row };
  };

  const addControls = (headingWrap, row) => {
    if (headingWrap.querySelector('.lg-intent-carousel__controls')) return;

    const controls = document.createElement('div');
    controls.className = 'lg-intent-carousel__controls';
    controls.setAttribute('aria-label', 'Genussmomente durchblättern');

    const previous = document.createElement('button');
    previous.type = 'button';
    previous.className = 'lg-intent-carousel__arrow';
    previous.setAttribute('aria-label', 'Vorherige Genussmomente');
    previous.innerHTML = '<span aria-hidden="true">←</span>';

    const next = document.createElement('button');
    next.type = 'button';
    next.className = 'lg-intent-carousel__arrow';
    next.setAttribute('aria-label', 'Weitere Genussmomente');
    next.innerHTML = '<span aria-hidden="true">→</span>';

    const update = () => {
      const maxScroll = Math.max(0, row.scrollWidth - row.clientWidth - 2);
      previous.disabled = row.scrollLeft <= 2;
      next.disabled = row.scrollLeft >= maxScroll;
    };

    const scrollPage = (direction) => {
      row.scrollBy({ left: direction * row.clientWidth, behavior: 'smooth' });
    };

    previous.addEventListener('click', () => scrollPage(-1));
    next.addEventListener('click', () => scrollPage(1));
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });

    controls.append(previous, next);
    headingWrap.appendChild(controls);
    requestAnimationFrame(update);
  };

  const initialize = () => {
    const section = findSection();
    if (!section || section.row.dataset.lgIntentCarouselReady === 'true') return;

    section.row.dataset.lgIntentCarouselReady = 'true';
    section.row.classList.add('lg-intent-grid--carousel');
    section.headingWrap.classList.add('lg-section-heading--intent-carousel');
    addControls(section.headingWrap, section.row);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
})();